import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Banknote, RefreshCw, Home, Briefcase, TrendingUp } from 'lucide-react';
export function Services() {
  const services = [{
    icon: Banknote,
    title: 'New Loans',
    description: 'Flexible loan products designed to meet personal and business financial needs with competitive rates.',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: RefreshCw,
    title: 'Debt Consolidation',
    description: 'Fix your net, clear your loans, and zero net balances. Lower monthly repayments with flexible terms.',
    color: 'bg-green-100 text-green-600'
  }, {
    icon: TrendingUp,
    title: 'Top-Up Loans',
    description: 'Available to existing customers. Fast processing and easy disbursement for home mods, education, or personal expenses.',
    color: 'bg-purple-100 text-purple-600'
  }, {
    icon: Home,
    title: 'Rehabilitation Loans',
    description: 'Finance home renovations, energy efficiency, accessibility upgrades, or disaster recovery.',
    color: 'bg-orange-100 text-orange-600'
  }, {
    icon: Briefcase,
    title: 'Micro Loans',
    description: 'Small loans for individuals or businesses requiring limited funding to start a project or support operations.',
    color: 'bg-teal-100 text-teal-600'
  }];
  return <Section id="services" bg="offwhite" data-id="element-405">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-406">
        <h2 className="text-gold font-bold tracking-wider text-sm uppercase mb-2" data-id="element-407">
          Our Services
        </h2>
        <h3 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-408">
          Tailored Financial Solutions
        </h3>
        <p className="text-gray-600" data-id="element-409">
          Comprehensive loan products designed to meet your specific needs at
          every stage of life or business.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-410">
        {services.map((service, index) => <Card key={index} delay={index * 0.1} className="h-full hover:-translate-y-1 transition-transform duration-300" data-id="element-411">
            <div className={`w-12 h-12 ${service.color} rounded-lg flex items-center justify-center mb-6`} data-id="element-412">
              <service.icon className="h-6 w-6" data-id="element-413" />
            </div>
            <h4 className="text-xl font-bold text-navy mb-3" data-id="element-414">
              {service.title}
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-415">
              {service.description}
            </p>
          </Card>)}
      </div>
    </Section>;
}